export type Dimension = {
  name: string;
  value: number;
  unit: string | null;
};

export function getValue(dimensions: Dimension[], name: string) {
  const entry = dimensions.find((d) => d.name === name);
  return entry?.value;
}

export function getBoolean(dimensions: Dimension[], name: string) {
  const value = getValue(dimensions, name);
  if (value === 1) {
    return true;
  } else if (value === 0) {
    return false;
  } else {
    return undefined;
  }
}

export function putValue(
  name: string,
  value: number,
  unit: string | null = null
) {
  return { name, value, unit };
}

export function putBoolean(name: string, value: boolean | undefined) {
  function toValue() {
    if (value === undefined) {
      return -1;
    }
    return value ? 1 : 0;
  }

  return putValue(name, toValue(), "boolean");
}

export function getNumber(dimensions: Dimension[], name: string) {
  return getValue(dimensions, name) ?? NaN;
}

export function getTimestamp(dimensions: Dimension[], name: string) {
  const entry = dimensions.find((d) => d.name === name);
  return entry ? new Date(entry.value) : undefined;
}
